export default class Invitation {
    id;
    status;
    email;
    notice;
    created;
    resent;
    inviter;

    constructor(props) {
        Object.assign(this, props);
    }
}
